import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import LicensePlate from "vue-license-plate";
import "vue-license-plate/lib/licensePlate.css";
import LicensePlateKeyboard from "license-plate-keyboard";
import "amfe-flexible";
import "./utils/register-vant";
import mixin from "./utils/mixin";
Vue.use(LicensePlate);
Vue.use(LicensePlateKeyboard);
Vue.config.productionTip = false;
Vue.mixin(mixin);
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
